import { RoleListTable } from '../components/RoleListTable';

export function RoleListPage() {
  return <RoleListTable />;
}
